// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHamburgerMenuIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M4.28 8.5h16a1.25 1.25 0 0 0 0-2.5h-16a1.25 1.25 0 0 0 0 2.5M20.28 11.03h-16a1.25 1.25 0 0 0 0 2.5h16a1.25 1.25 0 0 0 0-2.5M20.28 16h-16a1.25 1.25 0 0 0 0 2.5h16a1.25 1.25 0 0 0 0-2.5" />
  </g>
);
export default SvgHamburgerMenuIcon;
SvgHamburgerMenuIcon.displayName = 'SvgHamburgerMenuIcon';
